module.exports = "<zmat-map #_map_estacoes_\n    [data]=\"data\"\n    [schema]=\"mapSchema\"\n    [facade]=\"facade\"> \n</zmat-map>\n"